import { useSetGiveawayFeatured } from '@/hooks/queries'
import { cn } from '@/lib/cn'
import type { Giveaway } from '@/models/giveaway'

/**
 * Admins only: put the giveaway on the home page's featured list, or take it
 * off. The featured list only shows giveaways that haven't finished.
 */
export function FeatureButton({ giveaway }: { giveaway: Giveaway }) {
  const setFeatured = useSetGiveawayFeatured()
  const featured = giveaway.is_featured
  if (giveaway.id === null) return null
  const id = giveaway.id

  return (
    <button
      type="button"
      className={cn('action-btn', featured && 'is-active')}
      aria-pressed={featured}
      disabled={setFeatured.isPending}
      title={
        featured
          ? 'On the home page. Click to remove it.'
          : giveaway.has_ended
            ? "This giveaway has finished, so it won't show on the home page."
            : 'Show this giveaway on the home page.'
      }
      onClick={() => setFeatured.mutate({ id, featured: !featured })}
    >
      <svg
        viewBox="0 0 16 16"
        fill={featured ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="1.4"
        aria-hidden="true"
      >
        <path
          d="M8 1.8l1.9 3.9 4.3.6-3.1 3 .7 4.3L8 11.6l-3.8 2 .7-4.3-3.1-3 4.3-.6z"
          strokeLinejoin="round"
        />
      </svg>
      {featured ? 'Featured' : 'Feature'}
    </button>
  )
}
